"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var hub_1 = __importDefault(require("./hub"));
var HubMetrify = /** @class */ (function (_super) {
    __extends(HubMetrify, _super);
    function HubMetrify(data) {
        if (data === void 0) { data = {}; }
        var _this = _super.call(this, data) || this;
        _this.entity = 'feature';
        _this.action = 'metrify';
        return _this;
    }
    return HubMetrify;
}(hub_1.default));
exports.default = HubMetrify;
